export const INTENT_COLORS = ['#267E63', '#DA70BF', '#5879DA'];
export const enum TEXT_TYPE {
  PLAIN = 'PLAIN',
  HTML = 'HTML',
  PDF = 'PDF',
}
export const enum NODE_TYPE {
  ELEMENT_NODE = 'ELEMENT_NODE',
  TEXT_NODE = 'TEXT_NODE',
  WHITE_SPACE = 'WHITE_SPACE',
}
export const DELETE_ICON_SIZE = 22;
export const enum HYPERLINK_IDENTIFIER {
  START = '<link>',
  END = '</link>',
}
export const SHORTCUT_REGISTRATION_ERROR: {
  MESSAGE: 'Shortcut key is already registered.';
  TYPE: 'SHORTCUT_KEY_ALREADY_EXISTS';
} = Object.freeze({
  TYPE: 'SHORTCUT_KEY_ALREADY_EXISTS',
  MESSAGE: 'Shortcut key is already registered.'
});
export const EMPTY_ARRAY = [];